export enum VIDEO_PLAYER_SIZE {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  EXTRA_LARGE = "extra-large",
  VERTICAL = "vertical",
  FULL_WIDTH = "full-width",
}

export type VideoPlayerProps = {
  btnText?: string;
  sizeComp?: VIDEO_PLAYER_SIZE;
  previewImageSrc?: string;
  transcription?: string;
  videoSrc: string;
  videoTitle?: string;
  videoLang?: string;
  playButtonLabel?: string;
  videoAriaLabel?: string;
  transcriptionHeading?: string;
  transcriptionHeadingLevel?: "h2" | "h3" | "h4" | "h5" | "h6";
  showDivider?: boolean;
};
